import { client } from './client'

export const getDiagnoseFacilities = async (params) => {
  const response = await client.get('/api/nursing_facilities/diagnose/', { params })
  const data = response.data
  return data
}
